exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Input {\n  margin-bottom: 0.5rem;\n  position: relative;\n}\n.Input label {\n  visibility: hidden;\n  padding-left: 13px;\n  margin-bottom: -10px;\n  font-size: 90%;\n  color: #aaa;\n}\n.Input.has-value label {\n  visibility: visible;\n}\n.Input.inline {\n  display: inline-block;\n}\n.Input .spin-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: #007bff;\n  animation: fa-spin 0.7s infinite linear;\n}\n", ""]);

// exports
